import React from 'react';
import classes from './Login.module.scss';
import {Link} from 'react-router-dom';

let error = '';
class Login extends React.Component{

    handleSubmit(value){
        if(value.username === "name" && value.password === "pass"){

        }else{
            error = '*Please enter the correct username and passord';
        }
        console.log(value.username);
    }

    render(){
        return(
            <div className={classes.box}>
                <h1>CYST Login</h1>
                <form onSubmit={this.handleSubmit}>
                    <div className={classes.inputBox}>
                        <p>Username</p>
                        <input type="text" name="username" required=""/>
                    </div>
                    <div className={classes.inputBox}>
                      <p>Password</p>
                        <input type="text" name="password" required=""/>
                    </div>
                    <Link to='/landing'><input type='submit' name="submit" value="Login"></input></Link>
                    
                </form>
                <p className={classes.error}>{error}</p>
            </div>
        );
    }
}

export default Login;